const JOBS_TYPE = 'Jobs';
const MAIN_JOBS_TYPE = 'MainJobs';
const QUEUED_JOBS_TYPE = 'QueuedJobs';
const HISTORY_JOBS_TYPE = 'HistoryJobs';
const SUBMIT_BATCH_TYPE = 'CreateBatch';
const BATCHES_TYPE = 'Batches';
const REPOSITORY_TYPE = 'Repository';

// Components brought with instant cloud
const LICENSE_RATE_PLAN_TYPE = 'LicenseRatePlan';
const API_KEYS_TYPE = 'ApiKeys';
const API_KEY_CARDS_TYPE = 'ApiKeyCards';
const API_KEY_CARD_TYPE = 'ApiKeyCard';
const JOB_LOG_TYPE = 'JobLog';
const JOB_LOG_PANEL_TYPE = 'JobLogPanel';
const JOB_DASHBOARD_TYPE = 'JobDashboard';

export {
  SUBMIT_BATCH_TYPE,
  BATCHES_TYPE,
  REPOSITORY_TYPE,
  // Components brought with instant cloud
  LICENSE_RATE_PLAN_TYPE,
  API_KEYS_TYPE,
  API_KEY_CARDS_TYPE,
  API_KEY_CARD_TYPE,
  JOBS_TYPE,
  MAIN_JOBS_TYPE,
  QUEUED_JOBS_TYPE,
  HISTORY_JOBS_TYPE,
  JOB_LOG_TYPE,
  JOB_LOG_PANEL_TYPE,
  JOB_DASHBOARD_TYPE,
};
